export default {
  customerPoolSwitch: 'customer_pool_switch', // 公海分组开关
  customerPublicContact: 'customer_public_contact', // 是否显示公海联系人
  trailTypeSwitch: 'trail_type_switch', // 跟进类型下拉菜单切换为更多的跟进类型
  emailNeedReview: 'email_need_review',
  importAdditionUser: 'import_addition_user', // 是否允许导入客户时，增加一列（user）
  opportunitySwitch: 'opportunity_switch', // 商机模块开关
  orderSwitch: 'order_switch', // 订单模块开关
  quotationSwitch: 'quotation_switch', // 报价单模块开关
  showCustomApproval: 'show_custom_approval', //是否允许进入自定义审批
};
